import React from 'react';
import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { parseDate, formatDate } from 'shared-components';
import { RiskIcon } from '../RiskAction/RiskIcon';

interface Props {
  label: string;
  value: string | React.ReactNode | React.ReactNode[];
  title?: string;
  isRisk?: boolean;
  className?: string;
  fullLabel?: string;
  isDate?: boolean;
}

export const SummaryRow = (props: Props) => {
  const { className, label, value, title, isRisk = false, fullLabel, isDate } = props;
  if (!value) {
    return null;
  }
  return (
    <Box className={className} borderTopWidth={1} _first={{ borderTopWidth: 0 }}>
      {title && (
        <Box fontWeight={'medium'} mt={3}>
          {title}
        </Box>
      )}

      <Flex gap={4} py={2} lineHeight={5} data-selector={'summary-row'} {...(isRisk && { 'data-risk': 'true' })}>
        <Flex width={'50%'} flexShrink={0} data-selector={'summary-label'} color={'muted'}>
          {fullLabel ? (
            <Tooltip hasArrow placement="top-start" label={fullLabel}>
              {label}
            </Tooltip>
          ) : (
            <>{label}</>
          )}
        </Flex>

        <Box
          flexGrow={1}
          data-selector={'summary-value'}
          fontWeight={'medium'}
          wordBreak={'break-word'}
          sx={{ fontVariantNumeric: 'tabular-nums' }}
          {...(isRisk && { color: 'orange.700', _dark: { color: 'orange.400' } })}
        >
          {isDate ? formatDate(parseDate(value as string), 'DD/MM/YYYY') : value}

          {isRisk ? (
            <>
              {' '}
              <RiskIcon />
            </>
          ) : null}
        </Box>
      </Flex>
    </Box>
  );
};
